export const DECK_LIBRARY = [
  {
    key: "investor",
    title: "Investor Deck",
    filename: "DCYB-Investor-Deck.pdf",
    pages: "10 Pages",
    sub: "The AI infrastructure buildout — market, model, traction, and the ask.",
    audience: "For investors",
  },
  {
    key: "supply",
    title: "Supply Deck",
    filename: "DCYB-Supply-Deck.pdf",
    pages: "6 Pages",
    sub: "Release 01 — the gated merchandise and recognition line for members.",
    audience: "For members",
  },
  {
    key: "ventures",
    title: "Ventures Deck",
    filename: "DCYB-Ventures-Deck.pdf",
    pages: "6 Pages",
    sub: "The DCYB incubation model for building digital-infrastructure companies.",
    audience: "For founders & operators",
  },
];